<template>
  <div>
    <div v-if="activeName === 'second'">
      <!-- 未结算 -->
      <div class="search">
        <div class="search_box">
          <div class="searchItem">
            <div class="label">业务员</div>
            <div class="field">
              {{ this.$store.getters.loginUser.username }}
            </div>
          </div><div class="searchItem">
            <div class="label">项目编号</div>
            <div class="field">
              <el-input v-model.trim="query.projectcode" clearable></el-input>
            </div>
          </div>
          <div class="searchItem">
            <div class="label">项目名称</div>
            <div class="field">
              <el-input v-model.trim="query.projectname" clearable></el-input>
            </div>
          </div>
          <div class="searchItem">
            <div class="search_btn">
              <el-button type="primary" @click="search">查询</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vggrid
      :random="Math.floor(Math.random() * 999999)"
      :list="list"
      tableheight="400"
      flexname=""
      :cols="cols"
      :showfooter="false"
      :showPage="true"
      :resizable="true"
      :defaultPage="10"
      :total="query.total"
      @cellClick="cellClick"
      @cellDblClick="viewProject"
      @pagechange="pagechange"
    >
      <template slot="btn">
        <span
          >共{{ query.total }}个项目，服务费合计{{
            amt.fwfprice | Thousands
          }}元</span
        >
      </template>
    </vggrid>
  </div>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import vggrid from "../../views/common/vggrid";
import dayjs from "dayjs";
export default {
  name: "ywyNotReached",
  data() {
    return {
      cols: [
        {
          field: "projectcode",
          fieldtype: "I",
          title: "项目编号",
          calculExpr: "",
        },
        {
          field: "projectname",
          fieldtype: "I",
          title: "项目名称",
          calculExpr: "",
        },
        {
          field: "Pcomname",
          fieldtype: "I",
          title: "采购人",
          calculExpr: "",
        },
        {
          field: "projectlimitamt",
          fieldtype: "I",
          title: "预算额（元）",
          calculExpr: "",
        },
        {
          field: "ptcusername",
          fieldtype: "I",
          title: "业务员",
          calculExpr: "",
        },
        {
          field: "confirmfeeamt",
          fieldtype: "I",
          title: "服务费（元）",
          calculExpr: "",
        },
        {
          field: "projectreviewfeeCN",
          fieldtype: "I",
          title: "评审费",
          calculExpr: "",
        },
        {
          field: "faliReason",
          fieldtype: "I",
          title: "原因",
          calculExpr: "",
        }
      ],
      list: [],
      amt: {},
      query: {
        isMyself: 1,
        salerewardflg: 0,
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        total: 0,
        limit: 10,
        offset: 0,
      }
    };
  },
  components: { vggrid },
  async activated() {
    await this.getNotReached();
  },
  async mounted() {
    await this.getNotReached();
  },
  props: {
    activeName: {}
  },
  watch: {
    async activeName() {
      this.list = [];
      if (this.activeName === "second") {
        await this.getNotReached();
      }
    },
  },
  filters: {
    Thousands(val) {
      return val ? utils.comdify(val) : 0;
    }
  },
  methods: {
    search() {
      this.query.offset = 0
      this.getNotReached();
    },
    async getNotReached() {
      this.query.isMyself = 1;
      this.query.salerewardflg = 0;

      let res = await request({
        url: "/basic/statisticalAnalysis/getNotReached",
        method: "get",
        params: this.query,
      });
      res.data.map((e) => {
        e.psufewreceivetime = utils.formatterDate(
          e.psufewreceivetime,
          "yyyy-MM-dd"
        );

        e.projectlimitamt = utils.comdify(e.projectlimitamt);
        e.confirmfeeamt = utils.comdify(e.confirmfeeamt);
        e.projectreviewfeeCN = e.projectreviewfee === 1 ? '有' : '无';
        return e;
      });
      this.list = res.data;
      this.query.total = res.count[0].count;
      this.amt = res.amt;
    },
    async cellClick(row) {
      this.model = row;
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getNotReached();
    },
    async viewProject(row) {
      this.model = row;
    }
  },
};
</script>

<style scoped>
</style>
